import {RoundModel} from "./roundTypes";
import {useQuery} from "react-query";

import {getAxios} from "../../axios/generic-api-calls";

export function useFetchRounds(id:number,key:string = 'rounds') {
    return useQuery<RoundModel[]>(key, () => getAxios(`event/${id}/rounds`));
}

export function useFetchRoundById(id:number, key:string = 'round') {
    return useQuery<RoundModel>(key, () => getAxios(`round/${id}`));
}

export function useFetchCurrentRound(key:string = 'round.current') {
    return useQuery<RoundModel>(key, () => getAxios(`round/current`));
}
